import { get, post, put, delone } from "../config/httpConfig";

//老人相关接口
//----获取老人表格信息 分页检索等等
export const getOlderList = p => get("/api/theold", p);
//-----查询获取老人详情
export const getOlderDetail = p => get("/api/theold/detail", p);
// ----添加老人基础信息
export const addOneOlder = p => post("/api/theold", p);
//----更新老人基础信息
export const updateOlder = p => put("/api/theold", p);
//----删除老人
export const deleteOlder = p => delone("/api/theold", p);

//-------老人人脸识别注册
export const olderFace = p => put("/api/faceregister/theold", p);

//------获取老人联系人
export const olderContact = p => get("/api/usercontact", p);
//-----添加一个联系人
export const addContact = p => post("/api/usercontact", p);
export const editOlderBase = p => put("/api/theold", p);
//---删除一个联系人
export const delContact = p => delone("/api/usercontact", p);
//----编辑一个联系人
export const editContact = p => put("/api/usercontact", p);
//----提交养老服务申请
export const addServiceApprove = p => post("/api/approvalrecord", p);

//---服务中心的人暂停和开通养老服务
export const purseOlderAged = p => put("/api/agedservice", p);

//---服务中心的人 更新老人的类型
export const updateAgedInfo = p => put("/api/agedservice/info", p);

//----查询老人的同户老人
export const searchSameAccount = p => get("/api/samehousehold", p);

//审批相关
//---获取审批列表
export const getApproveList = p => get("/api/approvalrecord", p);
//--更新审批
export const updateOneApprove = p => put("/api/approvalrecord", p);

//更新同户老人谁享受补贴
export const updateSameAccount = p => put("/api/samehousehold", p);

//服务商
//----获取列表
export const getServiceProvider = p => get("/api/serviceprovider", p);

//----新增服务商
//---服务商基础信息
export const addProviderBase = p => post("/api/serviceprovider", p);
export const putProviderBase = p => put("/api/serviceprovider", p);

//---服务商机构证件

export const addProviderPaper = p => put("/api/serviceprovider/license", p);

//----服务商主图

export const addProviderImg = p => put("/api/serviceprovider/picture", p);

//----服务商财务信息
export const addProviderMoney = p => post("/api/unitaccount", p);
export const putProviderMoney = p => put("/api/unitaccount", p);

//----服务商账号
//---获取服务商账号信息   只需要根据token即可判断出来
//新增 或者更新
export const addProviderAccount = (p, head) => post("/api/unitadmin", p, head);

//更改当前登录用户的密码
export const updateCurrentPwd = (p, head) => post("/api/password", p, head);
//服务中心  获取某个服务商账号信息

//服务中心  获取某个服务商账号信息

//服务中心  获取某个服务商账号信息
//删除一个管理员账号
export const deleteProviderAdmin = p => delone("/api/unitadmin", p);

//服务中心  获取某个服务商账号信息

export const getProviderAdmin = p => get("/api/unitadmin/center", p);
//获取服务商财务信息
export const getProviderMoney = p => get("/api/unitaccount", p);

//获取所有服务项
export const getProjectList = p => get("/api/serviceitem", p);

//删除一个家政服务商  养老机构 社区  餐厅
export const delOneOrg = p => delone("/api/serviceprovider", p);

//获取一个服务项的详情
export const getProjectDetail = p => get("/api/serviceitem/detail", p);

//获取一个服务项的sku规格
export const getProjectSku = p => get("/api/serviceitemsku", p);

//-------获取一个服务商的基础信息
export const getProviderInfo = p => get("/api/serviceprovider/detail", p);

/*获取服务类型*/
export const getServeType = p => get("/api/ServiceCategory", p);
/**添加服务类型 */
export const addServeType = p => post("/api/ServiceCategory", p);
/**编辑服务类型 */
export const editServeType = p => put("/api/ServiceCategory", p);
/**删除服务类型 */
export const deleteServeType = p => delone("/api/ServiceCategory", p);

//服务商的服务项
export const getServiceItemApi = p => get("/api/serviceitem", p);

//----服务商管理人员相关        ---添加员工
export const addStaff = p => post("/api/servicepersonnel", p);
//---获取所有员工列表
export const getStaff = p => get("/api/servicepersonnel", p);
//----获取服务人员详情
export const getStaffDetail = p => get("/api/servicepersonnel/detail", p);
//----删除员工
export const deleteOneStaff = p => delone("/api/servicepersonnel", p);

//社区
//-------获取所有社区下拉列表
export const getCommunity = p => get("/api/community", p);

//获取社区基础信息
export const getCommunityDetail = p => get("/api/community/detail", p);
//获取社区管理员账号
// export const getCommunityAdmin = p => get("/api/community/detail", p)
//统计审批统计接口相关
export const getApprove = p => get("/api/approvalrecordstatistics", p);

//老人统计相关接口
//老人类型
export const getOlderStasticApi = p => get("/api/theoldstatistics/type", p);
//老人钱包统计
export const getOlderAccountStasticApi = p =>
  get("/api/theoldstatistics/account", p);

//评价
//获取评价
export const getProviderEval = p => get("/api/evaluation", p);

//账单
export const getProviderBill = p => get("/api/bill", p);

// /获取评价
// 获取评价列表
//api/evaluation
export const getAllEvaluation = p => get("/api/evaluation", p);

//账单查询
export const getBill = p => get("/api/bill", p);

//财务相关统计接口
export const getFinancestatistics = p =>
  get("/api/financestatistics/settlement", p);

// 交易记录统计
export const getFinancestatisticsAccount = p =>
  get("/api/FinanceStatistics/account", p);

// // 补贴发放消费记录

export const getFinancestatisticsAllowance = p =>
  get("/api/FinanceStatistics/allowance", p);

//获取行政区域
export const getDistrict = p => get("/api/district", p);

//获取老人列表 excel
export const getOlderExcel = p => get("/api/theoldexcel", p);

/**
 * 更改订单状态
 */
export const updateOrderApi = p => put("/api/order/changeorder", p);

//--------------------------------------------------------------------------------------------------------------

//工单相关

//工单相关  服务订单
export const getServiceOrder = p => get("/api/order/callcenter", p);
//订单详情
export const getServiceOrderDetail = p => get("/api/order/detail", p);
//取消订单
export const postServiceOrderCancel = p => post("/api/refund", p);
// export const postServiceOrderStatus = p => post("/api/order/status", p);

//服务人员列表

export const getServicePerson = p => get("/api/servicepersonnel", p);

//派单
export const putDistribute = p => put("/api/order/distribute", p);

//开始服务
export const postStartService = p => post("/api/housekeeping/start", p);

//结束服务
export const postEndService = p => post("/api/housekeeping/end", p);

//添加订单异常
export const addOrderAbnormal = p => post("/api/orderrecord", p);

//---获取人脸登记列表
export const getFaceApproveList = p => get("/api/FaceUpdate/list", p);

//---获取人脸登记详情
export const getFaceApproveDetail = p => get("/api/FaceUpdate/detail", p);
//-------人脸信息更新
export const faceInfoUpdate = p => put("/api/FaceUpdate", p);
//回访记录相关接口
export const getFollowUpRecord = p => get("/api/orderFollowUpRecord/list", p);
export const createFollowUpRecord = p => post("/api/orderFollowUpRecord", p);


//未接通来电相关接口
export const losscallApi = {
  getList(p) {
    return get("/api/callrecord/noanswer", p);
  },
  handle(p) {
    return get("/api/callrecord/noanswer", p);
  }
}
// 报警工单
export const alarmorderApi = {
  statusStatistic(p) {
    //统计
    return get("/api/WorkOrder/statusStatistic", p);//handleGid: this.$store.state.auth.userGid  type:1
  },
  getList(p) {
    p.title = '报警工单';
    return get("/api/workorder", p);
  },
  detail(p) {
    return get("/api/workorder/detail", p);
  },
  add(p) {
    /*Type:6
    Title:报警工单
    Origin:腕表设备
    Content:用户李胜贤在2021/8/6 11:23:51触发了紧急呼叫，报警地址：重庆市大足区北环二路
    UserId:458e79ea-641b-4f1c-9d56-aca8011d52a0
    UserName:李胜贤
    Remark:手动创建
    */
    return post("/api/workorder", p);
  },
  accept(p) {
    //受理
    return get("/api/workOrder/accept", p);//id: 6108d3e727c61800100d0f31
  },
  handleClose(p) {
    return post("/api/workorder/handle", p);//id  HandledResult  HandledRemark
  },
  record(p) {
    return post("/api/workOrderRecord/byWorkOrderId", p);//workOrderId:610cd76b27c61800100d14f5
  },
  addRecord(p) {
    return post("/api/workOrderRecord/remark", p)//workOrderId:610cd76b27c61800100d14f5  content:拨打老人电话问候
  },
}
//报警工单呼叫记录
export const orderCallRecordApi = {
  oncall(p) {
    return post("/api/CallRecords/onCall", p);
  },
  hangup(p) {
    return post("/api/CallRecords/hangUp", p);
  },
  getlist(p) {
    return get("/api/CallRecords", p);
  }
}
/**定位相关  老人的位置记录  */
export const positionApi = {
  getOneOlderRecordApi(p) {
    return get("/api/location/user/latest", p);
  },
  getSomeOlderPosApi(p) {
    return get("/api/location/users", p);
  }
};